export enum DocumentationIssueType {
  ADVANCED_SHIPPING_NOTICE = 'Advanced Shipping Notice (ASN from SAP)',
  CARRIER_WAYBILL = 'Carrier Waybill (AWB or BOL)',
  CERTIFICATE_OF_MANUFACTURE = 'Certificate of Manufacture',
  CERTIFICATE_OF_ORIGIN = 'Certificate of Origin',
  COMMERCIAL_INVOICE = 'Commercial Invoice',
  ENGINEERS_CERTIFICATE = "Engineer's Certificate",
  EXPORT_DOCUMENTS = 'Export Documents',
  LETTER_OF_CREDIT = 'Letter Of Credit',
  ORDER_CONFIRMATION = 'Order Confirmation',
  PACKING_LIST = 'Packing List',
  OTHER = 'Other',
}
